export const buildRegisterPayload = function (firstname, lastname, country, touchpoint, language, username, password, mobile, acceptedTexts, humanCheck, recaptchaToken, companyProfileFields) {
  return JSON.stringify({
    firstname: firstname,
    lastname: lastname,
    country: country,
    touchpoint: touchpoint,
    userLanguage: language,
    username: username,
    password: password,
    mobile: mobile,
    acceptedTexts: acceptedTexts,
    registrationCheck: humanCheck,
    recaptchaToken: recaptchaToken,
    companyFields: companyProfileFields
  })
}

export const buildLegalTextsPayload = function (country, touchpoint, language) {
  return JSON.stringify({
    homeCountry: country,
    touchpointCountry: touchpoint,
    language: language
  })
}

export const buildSetPasswordPayload = function (username, confirmationCode, password) {
  return JSON.stringify({
    username: username,
    confirmationCode: confirmationCode,
    newPassword: password
  })
}

export const buildSetCountryPayload = function (country) {
  return JSON.stringify({
    country: country
  })
}

export const buildAuthenticationPayload = function (username, password, rememberMe, rid) {
  return JSON.stringify({
    username: username,
    password: password,
    rememberMe: rememberMe,
    rid: rid
  })
}

export const buildSaveLegalConsentPayload = function (texts, homeCountry, consentCountry) {
  return JSON.stringify({
    texts: texts,
    homeCountry: homeCountry,
    consentCountry: consentCountry
  })
}

export const buildConfirmUsernamePayload = function (username, code) {
  return JSON.stringify({
    username: username,
    confirmationCode: code
  })
}

export const buildConfirmProfilePayload = function (firstname, lastname, country, password, touchpoint, acceptedTexts) {
  return JSON.stringify({
    firstname: firstname,
    lastname: lastname,
    country: country,
    password: password,
    touchpoint: touchpoint,
    acceptedTexts: acceptedTexts
  })
}

export const buildSaveConsentPayload = function (grantedScopes) {
  return JSON.stringify({
    grantedScopes: grantedScopes
  })
}

export const buildGetAuthStatePayload = function (uid, requestId) {
  return JSON.stringify({
    uid: uid,
    requestId: requestId
  })
}

export const buildMmePayload = function (username, requestId) {
  return JSON.stringify({
    username: username,
    requestId: requestId
  })
}

export const buildSetEmailPayload = function (username, email, password) {
  return JSON.stringify({
    username: username,
    email: email,
    password: password
  })
}

export const buildChangeUsernamePayload = function (username, newUsername, password) {
  return JSON.stringify({
    username: username,
    mobile: newUsername,
    password: password
  })
}

export const buildRevokeSessionPayload = function (sessionId, rememberMeCode) {
  return JSON.stringify({
    sessionId: sessionId,
    rememberMeCode: rememberMeCode
  })
}

export const buildCompanyProfileFieldsPayload = function (language, country) {
  return JSON.stringify({
    country: country,
    language: language
  })
}
